export default __webpack_public_path__ + "static/media/chat-icon.7b1ff11e.svg";